import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { getLegalDocsServer } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'
import styles from './terms-use.module.scss'

const title = 'SamsungKnox.com Terms of Use'
const legalType = 'registration_terms_use'

const TermsUse = ({ legalDocsResponse }) => {
  return (
    <Layout id={legalType} title={`${title} | Knox Partner Program`}>
      <Container>
        <UspPageTitle title="terms and conditions" />
        <Row className={styles.termsAndConditionsWrapper}>
          <Col sm={12}>
            <LegalDocs
              title={title}
              agreements={legalDocsResponse.data}
              headerClassNames={styles.header}
              contentClassNames={styles.customListContent}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps() {
  const legalDocsResponse = await getLegalDocsServer([legalType])
  if (legalDocsResponse.statusCode !== 200) {
    return {
      redirect: {
        destination: '/en/404',
        permanent: false
      }
    }
  }
  return {
    props: { legalDocsResponse }
  }
}

export default TermsUse
